import { memo } from 'react';
import Navbar from '../../../library/Navbar';
import logo from '../../../img/Icims_logo.png';
import { Box } from 'rebass/styled-components';
import { H1, Text } from '../../../library';
import { useTranslation } from '../../../hooks/useTranslation';
import { string } from 'prop-types';
import { mailER } from '../../../utils/config';
import useCampaignData from '../../../data/useCampaignData';
import ReactHtmlParser from 'react-html-parser';

const AuthError = memo(({ content = null }) => {
	const { t } = useTranslation();
	const {
		data: { supportEmail, supportPhone },
	} = useCampaignData();

	const emailAndPhoneMessage = t(
		'Feel free to send an email to %s or call %s for further information.',
		{
			sprintf: [
				`<a href=mailto:${supportEmail}>${supportEmail}</a>`,
				`<a href=tel:${supportPhone}>${supportPhone}</a>`,
			],
		}
	);

	const emailOnlyMessage = t('Feel free to send an email to %s for further information.', {
		sprintf: [`<a href=mailto:${supportEmail}>${supportEmail}</a>`],
	});

	const phoneOnlyMessage = t('Feel free to call %s for further information.', {
		sprintf: [`<a href=tel:${supportPhone}>${supportPhone}</a>`],
	});

	const defaultMessage = t('Feel free to contact your recruiter for further information.');

	return (
		<Box>
			<Navbar logo={logo} />
			<Box>
				<H1 color="#174b80;" fontSize="24px" mb={3}>
					{content ??
						t('Your interview or test is not yet available on the platform.') +
							' ' +
							t('Please reconnect later.')}
				</H1>
				<Text textAlign="center">
					{supportEmail && supportPhone
						? ReactHtmlParser(emailAndPhoneMessage)
						: supportEmail
						? ReactHtmlParser(emailOnlyMessage)
						: supportPhone
						? ReactHtmlParser(phoneOnlyMessage)
						: defaultMessage}
				</Text>
			</Box>
		</Box>
	);
});

AuthError.propTypes = {
	content: string,
};

export default AuthError;
